import { RootState } from 'src/store';

export const selectToasts = (state: RootState) => state.toasts.toasts;
